import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#theme" }),
  /*#__PURE__*/_createTextVNode(" Theme ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Alert provide two different themes, "),
  /*#__PURE__*/_createVNode("code", null, "light"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createVNode("code", null, "dark"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_alert, {
        class: "mb-5",
        title: "success alert",
        type: "success",
        effect: "dark"
      }),
      _createVNode(_component_el_alert, {
        class: "mb-5",
        title: "info alert",
        type: "info",
        effect: "dark"
      }),
      _createVNode(_component_el_alert, {
        class: "mb-5",
        title: "warning alert",
        type: "warning",
        effect: "dark"
      }),
      _createVNode(_component_el_alert, {
        title: "error alert",
        type: "error",
        effect: "dark"
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}